import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-overseas-phone-dialog',
  templateUrl: './overseas-phone-dialog.component.html',
  styleUrls: ['./overseas-phone-dialog.component.scss'],
})
export class OverseasPhoneDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<OverseasPhoneDialogComponent>
  ) {}

  goEmail() {
    this.dialogRef.close('email');
  }

  goPassword() {
    this.dialogRef.close('password');
  }

  close() {
    this.dialogRef.close();
  }
}
